import app from '../../angular_app.es6';
import { sendNextButtonMessage } from '../../../approach-react/express/admin/common/navigation';

app.directive('nextButton', [ '$rootScope', ($rootScope) => {
  return {
    restrict: 'A',
    scope: {
      eventName: '@nextButton',
      disableNavButtons: '='
    },
    link: ($scope, $element) => {
      // data-disable-with="Please wait..."
      $element.bind('click', () => {
        $rootScope.$broadcast($scope.eventName);
        sendNextButtonMessage();
      });
    }
  };
} ]);
